import React from 'react';
import PropTypes from 'prop-types';
import { BodyText, Alert } from '@paypalcorp/pp-react';
import MessageWithHTML from '../MessageWithHtml';
export default function RecurringInfo({ orgName, amount }) {
  return (
    <Alert type="info" className="recurring-info">
      <BodyText>
        <MessageWithHTML
          id="common.recurring-checkbox.rp.helpText1"
          orgName={orgName}
          amount={amount}
        />
      </BodyText>
    </Alert>
  );
}

RecurringInfo.propTypes = {
  orgName: PropTypes.string,
  amount: PropTypes.string,
};
